import { render } from "./Guides.vue?vue&type=template&id=f08a7646"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__